import React from "react";
import { Sidebar } from "primereact/sidebar";
import moment from "moment";
import "moment/locale/fr";
import {
  countFilesRecursively,
  calculateTotalSizeRecursively,
} from "../utils/FilesOperation";
import { Actif, Individu, Societe } from "../interfaces";
import { TabView, TabPanel } from "primereact/tabview";
import { AWS_BUCKET_ENV,AWS_BUCKET_NAME } from "../config/awsParams";

interface SlidOverDetailActifProps {
  actif: Actif;
  visibleRight: boolean;
  setVisibleRight: (newvalue: boolean) => void;
}
const SlidOverDetailActif = ({
  actif,
  visibleRight,
  setVisibleRight,
}: SlidOverDetailActifProps) => {
  return (
    <Sidebar
      key={actif?.uuid}
      visible={visibleRight}
      position="right"
      onHide={() => setVisibleRight(false)}
    >
      <h5 className="inline-flex items-start my-4 text-xl font-bold  text-gexpertise-200 ">
        Informations actif
      </h5>
      <div className="flex items-center space-x-5 mb-5">
        <img
          src={
            actif?.photo_actif
              ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/actif_photos/${actif?.photo_actif}`
              : "/images/default_actif.png"
          }
          className={actif?.photo_actif ? "w-12 h-12" : "w-10 h-10"}
        />
        <span className=" ml-5 font-bold text-gray-800 text-lg">
          {actif?.nom_actif}
        </span>
        {actif.verified && (
          <img src="/images/verifie1.png" className="w-6 h-6" />
        )}
      </div>
      <hr />
      <div>
        <span className="font-bold text-black text-xl mt-5">Propriétés</span>
        <span className="flex text-lg mt-5 text-black  font-semibold">
          <img src="/images/referer.png" className="mr-2" />
          Intérlocuteur référant
        </span>
        {actif?.interlocuteur_referent_id !== null ? (
          <button className="flex items-center w-full px-4 py-5 space-x-1 transition-colors duration-200  gap-x-2 hover:bg-gray-100 focus:outline-none">
            <img
              className="object-cover w-10 h-10 rounded-full"
              src={
                actif?.interlocuteur_referent?.photo_user
                  ? `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/${actif?.interlocuteur_referent?.photo_user}`
                  : `https://${AWS_BUCKET_NAME}.s3.amazonaws.com/${AWS_BUCKET_ENV}/users_photos/profile.png`
              }
              alt="interlocuteur_referant"
            />
            <div className="text-left rtl:text-right">
              <h1 className="text-md font-semibold text-gray-700 capitalize dark:text-white">
                {actif?.interlocuteur_referent?.first_name +
                  " " +
                  actif?.interlocuteur_referent?.last_name}
              </h1>
              <p className="text-sm text-gray-400 dark:text-gray-400">
                {actif?.interlocuteur_referent?.email}
              </p>
            </div>
          </button>
        ) : (
          <div
            className="flex items-center p-4 mb-4 text-sm text-blue-800 rounded-lg bg-blue-50 mt-2"
            role="alert"
          >
            <svg
              className="flex-shrink-0 inline w-4 h-4 mr-3"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5ZM9.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3ZM12 15H8a1 1 0 0 1 0-2h1v-3H8a1 1 0 0 1 0-2h2a1 1 0 0 1 1 1v4h1a1 1 0 0 1 0 2Z" />
            </svg>
            <div>
              <span className="font-medium">
                Pas de réferant pour le moment
              </span>
            </div>
          </div>
        )}
        <span className="flex text-lg mt-5 text-black  font-semibold mb-2">
          Classe principale d'actif
        </span>
        <span className="text-md font-semibold text-gray-700 ml-8 mt-4 ">
          <strong> {actif.class_principale_actif}</strong>
        </span>

        <span className="flex text-lg mt-5 text-black  font-semibold mb-2">
        Numéro de taxe foncière
        </span>
        <span className="text-md font-semibold text-gray-700 ml-8 mt-4 ">
          <strong> {actif.numero_taxe}</strong>
        </span>

        <span className="flex text-lg mt-5 text-black  font-semibold">
          Propriétaire d'actif
        </span>
        <span className="text-sm font-semibold text-gray-700 ml-8 mt-4 w-full">
          {actif.individus?.length === 0 ? (
            <ul className="ml-8 space-y-2 overflow-auto ">
              {actif.societes?.map((societe: Societe) => (
                <li className="flex space-x-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path
                      fillRule="evenodd"
                      d="M3.75 2a.75.75 0 0 0 0 1.5H4v9h-.25a.75.75 0 0 0 0 1.5H6a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 1 7 10h2a.5.5 0 0 1 .5.5v3a.5.5 0 0 0 .5.5h2.25a.75.75 0 0 0 0-1.5H12v-9h.25a.75.75 0 0 0 0-1.5h-8.5ZM6.5 4a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5H7a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 7 4h-.5ZM6 7a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v.5A.5.5 0 0 1 7 8h-.5a.5.5 0 0 1-.5-.5V7Zm3-3a.5.5 0 0 0-.5.5V5a.5.5 0 0 0 .5.5h.5A.5.5 0 0 0 10 5v-.5a.5.5 0 0 0-.5-.5H9Zm-.5 3a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5V7Z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <strong>
                    {societe.nom_societe}
                    {"  "}
                    {societe.numéro_siren !== null && societe.numéro_siren}
                  </strong>
                </li>
              ))}
            </ul>
          ) : (
            <ul className="ml-8 space-y-2 overflow-auto max-h-16 ">
              {actif.individus?.map((individu: Individu) => (
                <li className="flex space-x-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 16 16"
                    fill="currentColor"
                    className="w-5 h-5"
                  >
                    <path d="M8 8a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM12.735 14c.618 0 1.093-.561.872-1.139a6.002 6.002 0 0 0-11.215 0c-.22.578.254 1.139.872 1.139h9.47Z" />
                  </svg>

                  <strong>{`${individu.nom_individu} ${individu.prenom_individu}`}</strong>
                </li>
              ))}
            </ul>
          )}
        </span>

        <span className="flex text-lg mt-5 text-black  font-semibold">
          <img src="/images/google-docs.png" className="mr-2" />
          Nombres de fichiers
        </span>
        <span className="text-sm font-semibold text-gray-700 ml-8 mt-4">
          {countFilesRecursively(actif)} fichier(s)
        </span>
        <span className="flex text-lg mt-5  font-normal">
          <img src="/images/taille.png" className="mr-2" />
          Taille
        </span>
        <span className="text-sm font-semibold text-gray-700 ml-8 mt-4">
          {calculateTotalSizeRecursively(actif)}
        </span>

        <span className="flex text-lg mt-5  font-normal">
          <img src="/images/portefeuille.png" className="mr-2" />
          Portefeuille(s)
        </span>
        <span className="text-md font-semibold text-gray-700 capitalize dark:text-white mx-8 mt-5"></span>
        <span className="flex text-lg mt-5  font-normal">
          <img src="/images/editer.png" className="mr-2" />
          Modifié
        </span>
        <span className="text-sm font-semibold text-gray-700 capitalize dark:text-white mx-8 mt-5">
          {actif?.updated_at && moment(actif?.updated_at).format("LLL")}
        </span>

        <span className="flex text-lg mt-5  font-normal">
          <img src="/images/cle.png" className="mr-2" />A accès
        </span>
        <div className="ml-10 my-2 flex">
          {actif.members.map((member) => (
            <img
              className="object-cover w-6 h-6 -mx-1 border-2 border-white rounded-full shrink-0"
              src={
                member.photo_user ? member.photo_user : "/images/profile.png"
              }
            />
          ))}
        </div>
        <span className="flex text-lg mt-5  font-normal">
          <img src="/images/notification.png" className="mr-2" />
          Activité(s)
        </span>
        <span className="text-sm font-semibold text-gray-700 capitalize mt-8">
          Date d'ajout : {moment(actif?.created_at).format("LLL")}
        </span>
        <br />
        <span className="text-sm font-semibold text-gray-700 capitalize mt-8">
          Dérniere modification :{" "}
          {actif?.updated_at &&
            moment(actif?.updated_at).locale("fr").fromNow()}
        </span>
      </div>
    </Sidebar>
  );
};

export default SlidOverDetailActif;
